exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".button-bottom[data-v-9c712c44] {\n  border-radius: 4px !important;\n  margin-left: 10px;\n}\n.high-light[data-v-9c712c44] {\n  color: blue;\n  font-weight: bold;\n}\n", ""]);

// exports
